import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_display_currency_price = _resolveComponent("display-currency-price")

  return (_openBlock(), _createBlock(_component_display_currency_price, {
    "icon-classes": "gfu-icon--small",
    tag: "span",
    "effective-price": $props.price,
    class: "_fw-eb gfu-bt--b1 _whs-nw _tc--base _flexinline _ai-c"
  }, {
    "effective-price": _withCtx(({ effectivePrice }) => [
      _createTextVNode(_toDisplayString(effectivePrice), 1 /* TEXT */)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["effective-price"]))
}